import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { userContext } from "../../stores/users/userContext";
import Contact from "../pages/contact";
import Downloaded from "../downloaded/downloaded";
import CreateVideo from "../grid/createVideo";
import Logout from "../logout/logout";
import MyCreations from "../mycreations/mycreations";
import Profile from "../pages/profile";
import About from "../pages/about";
import Home from '../pages/home';
import NotFound from "../pages/not_found_404";
import Pricing from "../pages/pricing";
import { SignUpLogin } from "../signupLogin/signupLogin";
import SubscriptionPlans from "../subscription/SubscriptionPlans";
import SubscriptionSuccess from "../subscription/SubscriptionSuccess";
import SubscriptionCancel from "../subscription/SubscriptionCancel";
import SubscriptionManagement from "../subscription/SubscriptionManagement";
import DnVideos from "../upLoadDownload/dnVideos";
import UpVideos from "../upLoadDownload/upVideos";
import Usage from "../pages/usage";


const Router = () => {
    const userStore = useContext(userContext);
    const navigate = useNavigate();
    const location = useLocation();
    const isAuthenticated = userStore.isUserAuth();
    const isStripeActive = userStore.isUserStripeActive();
    // Routing configuration table
    const routeConfig = {
        '/': { // Home page
            component: Home,
            authRequired: false,
            redirectIfAuth: false,
        },
        '/home/': {
            component: Home,
            authRequired: false,
            redirectIfAuth: false,
        },
        '/signup/': {
            component: SignUpLogin,
            authRequired: false,
            redirectIfAuth: 'stripe_check', // Special flag to check stripe status
        },
        '/login/': {
            component: SignUpLogin,
            authRequired: false,
            redirectIfAuth: 'stripe_check', // Special flag to check stripe status
        },
        '/logout/': {
            component: Logout,
            authRequired: false,
            redirectIfAuth: false,
        },
        '/about/': {
            component: About,
            authRequired: false,
            redirectIfAuth: false,
        },
        '/contact/': {
            component: Contact,
            authRequired: false,
            redirectIfAuth: false,
        },
        '/pricing/': {
            component: Pricing,
            authRequired: false,
            redirectIfAuth: false,
        },
        '/subscription/': {
            component: SubscriptionPlans,
            authRequired: false,
            redirectIfAuth: false,
        },
        '/subscription/success/': {
            component: SubscriptionSuccess,
            authRequired: true,
            redirectIfNotAuth: '/login/',
        },
        '/subscription/cancel/': {
            component: SubscriptionCancel,
            authRequired: false,
            redirectIfAuth: false,
        },
        '/subscription/manage/': {
            component: SubscriptionManagement,
            authRequired: true,
            redirectIfNotAuth: '/login/',
        },
        '/downloaded/': {
            component: Downloaded,
            authRequired: true,
            redirectIfNotAuth: '/login/',
        },
        '/create-video/': {
            component: CreateVideo,
            authRequired: true,
            redirectIfNotAuth: '/login/',
        },
        '/my-creations/': {
            component: MyCreations,
            authRequired: true,
            redirectIfNotAuth: '/login/',
        },
        '/download-video/': {
            component: DnVideos,
            authRequired: true,
            redirectIfNotAuth: '/login/',
        },
        '/upload-video/': {
            component: UpVideos,
            authRequired: true,
            redirectIfNotAuth: '/login/',
        },
        '/usage/': {
            component: Usage,
            authRequired: true,
            redirectIfNotAuth: '/login/',
        },
        '/profile/': {
            component: Profile,
            authRequired: true,
            redirectIfNotAuth: '/login/',
        }
    };

    useEffect(() => {
        // Get the current path configuration
        const currentPath = location.pathname.endsWith('/') ? location.pathname : `${location.pathname}/`;
        const routeData = routeConfig[currentPath];

        // If path doesn't exist in our config, show 404
        if (!routeData && currentPath !== '/') {
            navigate('/404/');
            return;
        }

        // Handle authentication-based redirects
        if (routeData) {
            if (isAuthenticated && routeData.redirectIfAuth) {
                if (routeData.redirectIfAuth === 'stripe_check') {
                    // Handle Stripe status check for authenticated users
                    navigate(isStripeActive ? '/downloaded/' : '/');
                } else {
                    navigate(routeData.redirectIfAuth);
                }
            } else if (!isAuthenticated && routeData.authRequired) {
                navigate(routeData.redirectIfNotAuth);
            }
        }

    }, [location, isAuthenticated, isStripeActive]);

    // Generate routes based on authentication status
    const routes = Object.entries(routeConfig).map(([path, config]) => {
        if ((config.authRequired && isAuthenticated) || !config.authRequired) {
            return <Route key={path} exact path={path} element={<config.component />} />;
        }
        return null;
    }).filter(Boolean);

    return (
        <Routes>
            {routes}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default observer(Router);